"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var temp = function BuildTwoTone(primaryColor, secondaryColor) {
    return {
        name: 'build',
        theme: 'twotone',
        nameWithTheme: 'build-twotone',
        tag: 'svg',
        attrs: {
            xmlns: 'http://www.w3.org/2000/svg',
            class: 'icon',
            viewBox: '0 0 1024 1024'
        },
        children: [
            {
                tag: 'path',
                attrs: {
                    fill: secondaryColor,
                    d: 'M144 546h200v200H144zm268-268h200v200H412z'
                },
                children: []
            },
            {
                tag: 'path',
                attrs: {
                    d: 'M916 210H376c-17.7 0-32 14.3-32 32v236H108c-17.7 0-32 14.3-32 32v272c0 17.7 14.3 32 32 32h540c17.7 0 32-14.3 32-32V546h236c17.7 0 32-14.3 32-32V242c0-17.7-14.3-32-32-32zM344 746H144V546h200v200zm268 0H412V546h200v200zm0-268H412V278h200v200zm268 0H680V278h200v200z',
                    fill: primaryColor
                },
                children: []
            }
        ]
    };
};
temp.nameWithTheme = 'build-twotone';
var BuildTwoTone = temp;
exports.default = BuildTwoTone;



//////////////////
// WEBPACK FOOTER
// /Users/jim/Documents/GitHub/chenshuai/ant-design-pro-site/scaffold/node_modules/@ant-design/icons/lib/twotone/BuildTwoTone.js
// module id = 1090
// module chunks = 0